<template>
  <div class="announcement-detail">
    <NoticeBar :visible="noticeVisible" :message="noticeMessage" :type="noticeType" :actions="noticeActions" @close="noticeVisible=false" />
    <div class="header">
      <button class="back-btn" @click="goBack">返回列表</button>
    </div>
    <div class="content" v-if="announcement">
      <h2 class="title">{{ announcement.title }}</h2>
      <div class="image" v-if="announcement.image || announcement.image_url">
        <img :src="resolveUrl(announcement.image_url || announcement.image)" alt="公告图片" />
      </div>
    </div>
    <div class="empty" v-else>
      正在加载公告...
    </div>
  </div>
</template>

<script>
import NoticeBar from './NoticeBar.vue'
export default {
  name: 'AnnouncementDetail',
  components: { NoticeBar },
  props: {
    id: { type: [String, Number], required: true }
  },
  data() {
    return { announcement: null, noticeVisible: false, noticeMessage: '', noticeType: 'info', noticeActions: [] };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    resolveUrl(path) {
      if (!path) return '';
      if (path.startsWith('http')) return path;
      return path.startsWith('/') ? path : `/${path}`;
    },
    async fetchDetail() {
      try {
        const res = await fetch(`/api/admin/announcement/public/${this.id}/`);
        if (!res.ok) throw new Error('获取公告详情失败');
        const data = await res.json();
        this.announcement = data;
      } catch (e) {
        console.error(e);
        this.showNotice('获取公告详情失败', 'error');
      }
    },
    showNotice(message, type = 'info', actions = [], autoHideMs = 2500) {
      this.noticeMessage = message
      this.noticeType = type
      this.noticeActions = actions
      this.noticeVisible = true
      if (autoHideMs > 0) setTimeout(() => { this.noticeVisible = false }, autoHideMs)
    },
    goBack() {
      try {
        localStorage.setItem('redirect_to_active_exams', '1')
      } catch (e) { /* noop */ }
      window.location.hash = 'home';
      this.$emit('back');
    }
  }
}
</script>

<style scoped>
.announcement-detail { max-width: 880px; margin: 30px auto; background:#fff; padding: 20px; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.header { display:flex; justify-content:flex-start; margin-bottom: 10px; }
.back-btn { padding: 8px 12px; background:#f5f5f5; border:1px solid #ddd; border-radius: 4px; cursor:pointer; }
.title { margin: 10px 0 16px; color:#2c3e50; }
.image img { max-width: 100%; border-radius: 6px; }
.empty { color:#888; text-align:center; padding: 40px 0; }
</style>
